module.exports = __webpack_public_path__ + "static/Gibson-SemiBold-webfont-a039a5024597dd4f2dc03b09983c55ec.woff";